import { useState } from 'react'
import { AxiosError } from 'axios'

export const useApiErrors = () => {
  const [apiErrors, setApiErrors] = useState<string[]>([])
  const addApiError = (error: string) => setApiErrors(prevState => [...prevState, error])
  const addApiErrorFromAxios = (error: AxiosError) =>
    // @ts-ignore
    setApiErrors(prevState => [...prevState, ...(error?.response?.data?.errors || [])])
  const setApiErrorsFromAxios = (error: AxiosError, msg: string) =>
    setApiErrors([
      `${msg} (${error?.response?.status})`,
      // @ts-ignore
      ...(error?.response?.data?.errors || [error?.response?.data?.message] || []),
    ])

  return { apiErrors, setApiErrors, addApiError, addApiErrorFromAxios, setApiErrorsFromAxios }
}
